module.exports = __webpack_public_path__ + "static/media/logo_melian.631e66ba.svg";